import Image from 'next/image';
import Link from 'next/link';
import { motion } from 'framer-motion';
import styled from 'styled-components';
export const Container = styled(motion.div).withConfig({
  displayName: "SubMenuMobilestyle__Container",
  componentId: "sc-lgkqw8-0"
})(["", " box-shadow:0px 0px 0px 0px rgba(0,0,0,0.05),0px 1px 3px 0px rgba(0,0,0,0.05),0px 5px 5px 0px rgba(0,0,0,0.04),0px 11px 7px 0px rgba(0,0,0,0.03),0px 20px 8px 0px rgba(0,0,0,0.01),0px 31px 9px 0px rgba(0,0,0,0);"], {
  "position": "fixed",
  "left": "0px",
  "right": "0px",
  "top": "0px",
  "zIndex": "50",
  "overflowY": "scroll",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingBottom": "1.5rem",
  "paddingTop": "1rem"
});
export const ListContainer = styled(motion.div).withConfig({
  displayName: "SubMenuMobilestyle__ListContainer",
  componentId: "sc-lgkqw8-1"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "1.5rem"
});
export const MenuListContainer = styled(motion.div).withConfig({
  displayName: "SubMenuMobilestyle__MenuListContainer",
  componentId: "sc-lgkqw8-2"
})(["", ""], {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
});
export const MenuHeading = styled(motion.div).withConfig({
  displayName: "SubMenuMobilestyle__MenuHeading",
  componentId: "sc-lgkqw8-3"
})(["", ""], {
  "marginBottom": "1.5rem",
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between"
});
export const MenuTitle = styled.div.withConfig({
  displayName: "SubMenuMobilestyle__MenuTitle",
  componentId: "sc-lgkqw8-4"
})(["", ""], {
  "display": "flex",
  "gap": "1rem",
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(23 23 23 / var(--tw-text-opacity, 1))"
});
export const BackIcon = styled(Image).withConfig({
  displayName: "SubMenuMobilestyle__BackIcon",
  componentId: "sc-lgkqw8-5"
})(["", ""], {
  "width": "0.5rem",
  "cursor": "pointer"
});
export const CloseIcon = styled(Image).withConfig({
  displayName: "SubMenuMobilestyle__CloseIcon",
  componentId: "sc-lgkqw8-6"
})(["", ""], {
  "width": "18px",
  "cursor": "pointer"
});
export const ChildrenList = styled(motion.div).withConfig({
  displayName: "SubMenuMobilestyle__ChildrenList",
  componentId: "sc-lgkqw8-7"
})(["", " span{", "}"], {
  "position": "relative",
  "marginLeft": "0.75rem",
  "marginRight": "0.75rem",
  "overflowWrap": "break-word",
  "paddingLeft": "0.75rem"
}, {
  "position": "absolute",
  "left": "0px",
  "top": "0px",
  "--tw-text-opacity": "1",
  "color": "rgb(238 132 60 / var(--tw-text-opacity, 1))"
});
export const ChildrenListTitle = styled(Link).withConfig({
  displayName: "SubMenuMobilestyle__ChildrenListTitle",
  componentId: "sc-lgkqw8-8"
})(["", " color:", ";&:hover{", "}"], {
  "fontSize": "1.5rem",
  "lineHeight": "2rem",
  "fontWeight": "400"
}, ({
  $isActive,
  theme
}) => $isActive ? theme.colors.primary[50] : theme.colors.grey[50], {
  "--tw-text-opacity": "1",
  "color": "rgb(43 43 43 / var(--tw-text-opacity, 1))"
});
export const WrapperOverlay = styled(motion.div).withConfig({
  displayName: "SubMenuMobilestyle__WrapperOverlay",
  componentId: "sc-lgkqw8-9"
})(["", " background:rgba(255,255,255,0.75);backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);"], {
  "position": "fixed",
  "left": "0px",
  "right": "0px",
  "top": "0px",
  "zIndex": "49",
  "height": "100vh"
});